export default {
    methods: {
        //funciones para el filtro
        customFilter(items, filters, filter, headers) {
            // Init the filter class.
            const cf = new this.$MultiFilters(items, filters, filter, headers);
            cf.registerFilter("nombre_unidad", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.nombre_unidad + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("estado", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.estado + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            return cf.runFilters();
        },

        filterNombreUnidad(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                nombre_unidad: val
            });
        },
        filterEstado(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                estado: val
            });
        },
        recargar() {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                nombre_unidad: ""

            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                estado: ""

            });
            this.form = {}
        },
    }
};


// WEBPACK FOOTER //
// ./src/components/admin/vacaciones/mixins/filtrosUnidades.js